export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";